<template>
<a-space direction="vertical" :class="endStationIndex ? 'verActive' : ''">
    <div v-if="!lineorder" class="address-choose">
        <a-button type="link" @click="handleSelect">
            <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
      <a-button v-if="!disabled && !ruleStation" type="link" @click="handleSmartRecognition">
        <img class="addressIcon" src="@/assets/img/icon_green_scan.png">智能地址识别
      </a-button>
    </div>
    <div>
        <a-row >
            <a-col :md="8" :sm="24">
                <a-form-model-item
                label="站点名称"
                :colon="false"
                >
                    <a-input v-model="endStation.stationName" placeholder="请输入"></a-input>
                </a-form-model-item>
            </a-col>
          <a-col :md="8" :sm="24">
            <a-form-model-item
                label="期望送达时间"
                :colon="false"
                :prop='`${propPrefix}.expectTime`'
                :rules="ruleTime?[]:[
                        { required: true, message: '请选择需要送达时间', trigger: 'change' },
                    ]"
            >
              <a-date-picker
                  v-if="!ruleTime"
                  v-model="endStation.expectTime"
                  :disabled-date="disabledDate"
                  :disabled-time="disabledDateTime"
                  :show-time="{ defaultValue: defaultTime }"
                  placeholder="请选择"
                  @change="handleChange"
                  @focus="handleFocus" />
              <div v-else>{{calDateTime(ruleTime)}}</div>
            </a-form-model-item>
          </a-col>
            <a-col :md="8" :sm="24">
                <FormItemName
                    v-model.trim="endStation.contactName"
                    :rule-station="ruleStation"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <FormItemPhone
                    v-model="endStation.contactPhone"
                    :rule-station="ruleStation"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                />
            </a-col>
            <a-col :md="16" :sm="24">
                <!-- <FormItemAddress
                    :address="endStation"
                    :prop-prefix="propPrefix"
                    :disabled="disabled"
                    @change="handleAdressChange"
                    /> -->
                <a-form-model-item
                    label="联系人地址"
                    :colon="false"
                    :label-col="{span: 3}"
                    :wrapper-col="{span: 21}"
                    :rules="addressRules"
                    :prop="`${propPrefix}.address`"
                >
                    <address-detil
                      :rule-station="ruleStation"
                      :default-address="defaultAddress"
                      :default-suffix="defaultSuffix"
                      :disabled="disabled"
                      @updateData="handleAdressChange"
                      @removeData="removeData">
                    </address-detil>
                </a-form-model-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
                <a-form-model-item
                    label="外部订单号"
                >
                <a-input v-model="endStation.crmNumber" class="orderNumStyle" placeholder="每个目的地填写不同的外部订单号" />
                </a-form-model-item>
            </a-col> -->
            <a-col v-if="!lineorder && mileage && !isPretend" :md="8" :sm="24">
                <a-form-model-item
                    label="预估里程"
                    :rules="rules"
                    :label-col="{span: 6}"
                    :wrapper-col="{span: 16}"
                    :prop="`${propPrefix}.mileageKm`"
                >
                    <a-input-number
                    v-model="endStation.mileageKm"
                    suffix="KM"
                    class="orderMileStyle"
                    :max="5000"
                    :min="0"
                    :formatter="limitDecimals"
                    :parser="limitDecimals"
                    placeholder="请输入预估里程" />
                </a-form-model-item>
            </a-col>
        </a-row>
        <slot></slot>
    </div>
    <SelectAddressDialog ref="SelectAddressDialog" :station-type="StationTypes.RECEIVING" :is-standard='true' @onSelectAddress="handleAdressFromSelectorChange"/>
    <smartRecognitionModal ref="smartRecognitionModalRef" @onConfirm="handleSmartConfirm"></smartRecognitionModal>
</a-space>
</template>
<script>
import moment from 'moment';
// import BlockPanel from '@/components/panel/BlockPanel.vue'
import FormValidator from '@/constants/formValidator'
import { mapState } from 'vuex'
import {TIME_UNIT,TIME_UNIT_MAP,range} from '@/constants/ruleConfig'
import SelectAddressDialog from '../../components/SelectAddressDialog'
import { StationTypes } from '../../constant';
import {
    FormItemName,
    FormItemPhone,
    // FormItemAddress
} from '../../components/FormItem'
import AddressDetil from './AddressDetil.vue'
import smartRecognitionModal from "../../components/smartRecognitionModal.vue";

export default {
    components: {
        // BlockPanel,
        SelectAddressDialog,
        FormItemName,
        FormItemPhone,
        // FormItemAddress,
        AddressDetil,
      smartRecognitionModal
    },
    model: {
        prop: 'endStation',
        event: 'change'
    },
    props: {
        endStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        propPrefix: {
            type: String,
            default: ''
        },
        showAddButton: {
            default: false,
            type: Boolean
        },
        showDeleteButton: {
            default: false,
            type: Boolean
        },
        lineorder: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },
        mileage: {
            default: false,
            type: Boolean
        },
        endStationIndex: {
            default: true,
            type: Boolean
        },
        endStationList: {
            default: ()=>[],
            type: Array
        },
        isPretend: {
            default: false,
            type: Boolean
        },
        ruleStation: {
          type: Object
        },
        ruleTime: {
          type: Object
        },
    },
    data () {
        return {
            defaultTime: moment('23:59:59', 'HH:mm:ss'),
            col: 8,
            wrapperCol: 14,
            FormValidator,
            StationTypes,
            rules:[
                { required: true, message: '请输入预估里程', trigger: 'change' },
            ],
            addressRules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ],
            defaultAddress: '',
            defaultSuffix: '',
            current:null,
        }
    },
     computed:{
      ...mapState('orderRules', ['orderRules']),
    },
    watch:{
        endStation:{
            handler(val){
                if(val.expectTimeLeft && val.expectTimeLeft.length>0){
                  this.defaultTime=moment(val.expectTimeLeft[0]||'23:59:59','HH:mm:ss')
                }else{
                  this.defaultTime=moment('23:59:59', 'HH:mm:ss')
                }
                if(val.address){
                    this.defaultSuffix = val.stationFullAddress
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
      calDateTime(val){
        return moment().minute(val.minute).hour(val.hour).add(val.day, 'days').format('YYYY-MM-DD HH:mm') || '--'
      },
       handleFocus(){
        this.current = new Date();
      },
      handleChange(value){
          if(!value){
            this.$set(this.endStation,'expectTime',null)
            return
          }
          const {createReachTimeNum,createReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          // 结束时间
          const endTime =  moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
         // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          if(isSameEnd){
            if(value > endTime){
              this.$set(this.endStation,'expectTime',moment(endTime))
            }else{
              this.$set(this.endStation,'expectTime',value)
            }
          }else{
            this.$set(this.endStation,'expectTime',value)
          }
      },
        disabledDate(current){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          let startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current).subtract(1, "days");
          let endTime =moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          if(makeupReachTimeUnit){
            startTime = moment(startTime).subtract(1 , 'days')
          }
          if(createReachTimeUnit === TIME_UNIT.HOURS){
            endTime = moment(endTime)
          }
          return current && moment(current).startOf('days') < startTime|| moment(current).startOf('days') > endTime
        },
        disabledDateTime(){
          return {
			      disabledHours: () => this.disabledHours(this.orderRules.ORDER_CREATE_TIME_CHECK),
			      disabledMinutes: () => this.disabledMinutes(this.orderRules.ORDER_CREATE_TIME_CHECK),
		      };
        },
        disabledHours(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 获取当前时间小时
          const currentHours = moment(this.current).hour();
          // 结束时间小时数计算
          const endHours = createReachTimeUnit === TIME_UNIT.HOURS? currentHours + createReachTimeNum:currentHours;
          // 开始时间小时数计算
          const startHours = makeupReachTimeUnit === TIME_UNIT.HOURS? currentHours - makeupReachTimeNum:currentHours;
          // hours数组
          const hoursList = range(0,24);
          // 结束禁用小时列表
          const endDisabledList =  hoursList.splice(hoursList.indexOf(endHours)+1,24);
          // 开始禁用小时列表
          const startDisabledList =  hoursList.splice(0,hoursList.indexOf(startHours));
          if(isSameEnd&&isSameStart){
            return [...startDisabledList,...endDisabledList]
          }
          if(isSameEnd){
            return endDisabledList
          }if(isSameStart){
            return startDisabledList
          }
          return []
        },
        disabledMinutes(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 开始时间是多少小时
          const startHours= flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]).hour():moment(this.current).hour();
          // 获取当前时间小时
          const currentHours = this.endStation.expectTime? moment(this.endStation.expectTime).hour():startHours;
          // 结束时间是多少小时
          const endHours=  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit]).hour()
          if(isSameStart&&currentHours === startHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(0,minuteList.indexOf(endMinute))
            return disabled
          }if(isSameEnd&&currentHours === endHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(minuteList.indexOf(endMinute)+1,60)
            return disabled
          }
          return []
        },
        limitDecimals (value){
            const reg = /^(-)*(\d+)\.(\d\d\d).*$/;
            return `${value}`.replace(reg,'$1$2.$3');
        },
        handleSelect() {
            this.$refs.SelectAddressDialog.show({})
        },
      handleSmartRecognition(){
        this.$refs.smartRecognitionModalRef.show()
      },
      handleSmartConfirm(smartData) { // 智能识别结果
        this.handleAdressFromSelectorChange(smartData)
      },
        handleAdressFromSelectorChange({
            contacts, telPhone,stationName,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode,sourceStationId, maxReceiptPeriodTime
        }) {
            const arr = []
            // 多装多卸不予许选择相同收货站点
            if(this.isPretend){
                this.endStationList.forEach((e) => {
                    if (e.provinceCode === provinceCode && e.cityCode === cityCode && e.countyCode === countyCode && e.address === address) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                this.update({
                    contactPhone: telPhone,
                    contactName: contacts,
                    provinceName,
                    cityName,
                    countyName,
                    address,
                    provinceCode,
                    cityCode,
                    countyCode,
                    stationId: sourceStationId,
                    stationName,
                })
                // 该站点是否已有收货时段,期望送达时间的结束时间
                if(maxReceiptPeriodTime) {
                    this.defaultTime = moment(`${maxReceiptPeriodTime}:00`, 'HH:mm:ss')
                } else {
                    this.defaultTime = moment('23:59:59', 'HH:mm:ss')
                }
            } else {
                this.$message.warning('收货地信息不能重复！')
            }
        },
        handleAdressChange(address) {
            const arr = []
            // 多装多卸不予许选择相同收货站点
            if(this.isPretend){
                this.endStationList.forEach((e) => {
                    if (e.provinceCode === address.provinceCode && e.cityCode === address.cityCode && e.countyCode === address.countyCode && e.address === address.address) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                const {province,city,county} = address
                this.update({
                    ...address,
                    provinceName: province,
                    cityName: city,
                    countyName: county,
                })
            } else {
                this.defaultAddress = ' '
                this.defaultSuffix = ' '
                this.$message.warning('收货地信息不能重复！')
            }
        },
        update(infos) {
            const {provinceName,cityName,countyName,address} = infos
            this.$emit('changeDetil')
            this.$emit('change', {
                ...this.endStation,
                ...infos,
                stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm, stationGoodsList, orderGoodsType} = this.endStation
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
                stationGoodsList,
            })
        },
    },
}
</script>

<style lang="less" scoped>
.address-choose {
  margin: 10px 0;
  .ant-btn {
    &:first-child {
      padding-left: 26px;
    }
  }
}
.verActive{
    margin-top: -10px;
}
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    .subtitle {
        flex: 1;
    font-weight: bold;
    font-size: 16px;
    }

}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
.btnStyle{
    margin-top: 8px;
}
/deep/ .ant-space-item{
    margin-bottom: 0 !important;
}
/deep/ .orderNumStyle{
    max-width: 302px !important;
    width: 100%;
}
/deep/ .orderMileStyle{
    width: 100%;
}
::v-deep .ant-card-bordered{
    border: none;
}
.adress-info-component{
    margin-bottom: 16px;
}
</style>
